<style lang="stylus" scoped>
    .text-container
        height 100%
        .text-top
            width 248px;
            padding 16px
            border-bottom 1px solid var(--border-color-gray1)
            .text-item-title
                text-align center
                color var(--text-color-primary);
                cursor pointer
                padding 8px 0;
                &:hover
                    background: var(--bg-color-left-panel-itext-hover);
                    border-radius 6px;
                &.fz-16
                    font-size 16px
                    font-weight 700
                    line-height 20px
                &.fz-14
                    font-size 14px
                    font-weight 700
                    line-height 18px
                &.fz-12
                    font-size 12px
                    line-height 16px
        .text-tab-container
            .text-tab
                margin 17px 0 16px 0;
                padding 0 16px;
                // height 28px;
                .tab-item
                    // padding-bottom 8px;
                    display inline-block
                    font-size 14px;
                    font-weight 700;
                    line-height 18px;
                    height 18px;
                    color: var(--text-color-primary)
                    // color rgba(1, 127, 255, 1);
                    // border-bottom 2px solid rgba(1, 127, 255, 1);
            .tab-content
                padding 0 16px 0 16px;
                .text-type
                    display grid;
                    grid-gap 8px
                    grid-template-columns repeat(3, 1fr);
                    margin-bottom 16px;
                    .type-item
                        width 66px;
                        height 24px;
                        border-radius 4px;
                        background: var(--bg-color-library-shape);
                        color: var(--text-color-primary);
                        font-size 12px;
                        line-height 24px;
                        text-align center;
                        font-weight 400;
                        cursor pointer
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        padding: 0 4px;
                        &:hover
                            color:  var(--themeColor);
                        &.active
                            color:  var(--themeColor);
                            background: var(--bg-color-left-panel-itext-active);
        .text-bottom
            width 248px;
            position relative
            height calc(100% - 260px)
            .skeleton
                position absolute;
                top 0;
                left 0;
                bottom 0;
                right 0;
                padding 16px 17px;
                z-index 1
                background #fff;
                @keyframes skeleton-loading {
                    0% {
                        background-position: 100% 50%;
                    }

                    to {
                        background-position: 0 50%;
                    }
                }
                .common-item {
                    border-radius: 6px;
                    background: linear-gradient(60deg, var(--bg-color-skl-loading-1) 25%, var(--bg-color-skl-loading-2) 37%, var(--bg-color-skl-loading-1) 63%);
                    background-size: 400% 100%;
                    animation: skeleton-loading 1.5s ease infinite;
                }
                .skeleton-top
                    padding:6px 0;
                    margin-bottom 16px;
                    display flex;
                    column-gap: 10px
                    .skeleton-item
                        width 66px
                        height 16px
                .skeleton-mid
                    display grid;
                    grid-gap 8px;
                    grid-template-columns repeat(3, 1fr)
                    margin-bottom 16px;
                    .skeleton-item
                        width 66px
                        height 24px
                .skeleton-bottom
                    display grid
                    grid-gap 8px;
                    grid-template-columns repeat(2, 1fr)
                    .skeleton-item
                        width 104px
                        height 60px

            .tab-content
                padding 0 16px 16px 16px;
                .text-type-content
                    // display grid;
                    // grid-gap 8px
                    // grid-template-columns repeat(2, 1fr)
                    display flex
                    flex-wrap wrap
                    column-gap 8px
                    row-gap 8px
                    .content-item
                        position relative
                        width 104px;
                        height 60px
                        border-radius 6px;
                        border: 1px solid var(--border-color-gray2)
                        cursor pointer
                        img
                            height 100%;
                            width 100%
                            object-fit: contain;
                        img[lazy=loading]
                            width 100%;
                            height 100%;
                            object-fit cover;
                        .content-icon
                            position absolute
                            right 8px
                            top 8px
                            width 12px
                            height 12px
                            pointer-events none
                    .text-empty
                        display flex
                        justify-content center
                        align-items center
                        width 100%
                        height 100%
                        p
                            font-size 14px
                            color #222
                    .text-loading
                        width 100%
                        display flex
                        justify-content center
                        svg
                            color var(--themeColor)
</style>

<template>
    <div class="text-container">
        <div class="text-top">
            <div class="text-item-title" :class="`fz-${item.uiSize}`" v-for="item in titleList" :key="item.title" @mousedown="doMousedown(item)">
                {{ $t(item.title) }}
            </div>
        </div>
        <div class="text-tab-container">
            <div class="text-tab">
                <span class="tab-item">{{ $t("textTemplate") }}</span>
            </div>
            <div class="tab-content">
                <div class="text-type">
                    <div
                        class="type-item"
                        :class="{ active: activeType === item.value }"
                        v-for="item in textType"
                        :key="item.label"
                        @click="handleClickType(item)"
                        v-textoverflow-with-tippy="{ content: $t(item.label), placement: 'bottom' }"
                    >
                        {{ $t(item.label) }}
                    </div>
                </div>
            </div>
        </div>
        <ScrollView class="text-bottom">
            <!-- <div class="skeleton" v-if="loading">
                <div class="skeleton-top">
                    <div class="skeleton-item common-item" v-for="i in 2" :key="i"></div>
                </div>
                <div class="skeleton-mid">
                    <div class="skeleton-item common-item" v-for="i in 6" :key="i"></div>
                </div>
                <div class="skeleton-bottom">
                    <div class="skeleton-item common-item" v-for="i in 22" :key="i"></div>
                </div>
            </div> -->
            <div class="tab-content">
                <div class="text-type-content">
                    <div class="content-item" v-for="(item, index) in textList" :key="`${item.url}-${index}`">
                        <img
                            v-lazy="item.imgSrc"
                            alt=""
                            draggable="false"
                            @mousedown="handleMousedown($event, item, index)"
                            @click.prevent="handleClickImg(item, index)"
                        />
                        <img v-if="!vip && index > 5" class="content-icon" src="@/public/img/vip.svg" alt="" />
                    </div>
                    <div v-show="!loading && isEmpty" class="text-empty">
                        <p>{{ $t("nodata") }}</p>
                    </div>
                    <div v-show="loading" class="text-loading">
                        <svg
                            version="1.1"
                            id="loader-1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            width="24"
                            height="24px"
                            viewBox="0 0 50 50"
                            style="enable-background: new 0 0 50 50"
                            xml:space="preserve"
                        >
                            <path
                                fill="currentColor"
                                d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
                            >
                                <animateTransform
                                    attributeType="xml"
                                    attributeName="transform"
                                    type="rotate"
                                    from="0 25 25"
                                    to="360 25 25"
                                    dur="0.8s"
                                    repeatCount="indefinite"
                                />
                            </path>
                        </svg>
                    </div>
                    <div v-show="!loading && !end" ref="scrollEl" style="width: 100%; height: 10px"></div>
                </div>
            </div>
        </ScrollView>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";

    import ScrollView from "@/public/components/ScrollView/ScrollView.vue";
    import GetSymbolLibraryData from "@/app/mixin/getSymbolLibraryDataMixin";

    @Component({
        components: {
            ScrollView,
        },
    })
    export default class IText extends GetSymbolLibraryData {
        loading = false;
        titleList = [
            {
                uiSize: 16,
                canvaSize: 36,
                title: "addTitle",
            },
            {
                uiSize: 14,
                canvaSize: 24,
                title: "addSubTitle",
            },
            {
                uiSize: 12,
                canvaSize: 12,
                title: "addContent",
            },
        ];
        textType = [
            {
                label: "2Items",
                value: 2,
            },
            {
                label: "3Items",
                value: 3,
            },
            {
                label: "4Items",
                value: 4,
            },
            {
                label: "5Items",
                value: 5,
            },
            {
                label: "mulItems",
                value: 1000,
            },
            {
                label: "smartItems",
                value: -1,
            },
        ];

        activeType = 3;

        pageInfo = {
            offset: 0,
            count: 20,
            shape_num: 3,
        };

        textList = [];

        end = false;

        baseHost = "";

        suffix = [];

        imgDom = null;

        textDom = null;

        observe = null;

        mouseMoveBack = false;

        get trackKey() {
            let t = this.textType.find((v) => v.value === this.activeType);
            return this.$tc(t.label, 1, "en");
        }

        get isEmpty() {
            return this.textList.length == 0;
        }

        get focusModeExpandLeft() {
            return this.$store.getters.expandLeft;
        }
        get sceneLeft() {
            if (!this.focusModeExpandLeft) return 0;
            return this.$store.state.ui.sceneLeft;
        }
        get focusModeExpandTop() {
            return this.$store.getters.expandTop;
        }
        get sceneTop() {
            if (!this.focusModeExpandTop) return 0;
            return this.$store.state.ui.sceneTop;
        }

        createPreview(url) {
            this.imgDom = document.createElement("img");
            this.imgDom.src = url;
            this.imgDom.id = "previewIMG";
            this.imgDom.style.cssText = `
                display: none;
                position:absolute;
                left: -999px;
                top: -999px;
                width: 32px;
                height: 32px;
                object-fit:contain;
                pointer-events:none;
                z-index: 1000;
            `;
            document.body.appendChild(this.imgDom);
        }

        createTextPreview(item) {
            this.textDom = document.createElement("div");
            this.textDom.innerText = this.$t(item.title);
            this.textDom.id = "previewTextIMG";
            this.textDom.style.cssText = `
                display: none;
                position:absolute;
                left: -999px;
                top: -999px;
                width: ${item.canvaSize === 36 ? 450 : item.canvaSize === 24 ? 350 : 120}px;
                height: 32px;
                object-fit:contain;
                pointer-events:none;
                z-index: 1000;
                font-size: ${item.canvaSize}pt;
                font-weight: ${item.canvaSize === 12 ? "normal" : 700}
            `;
            document.body.appendChild(this.textDom);
        }

        movePreview(dom, x: number, y: number) {
            if (dom) {
                dom.style.left = `${x}px`;
                dom.style.top = `${y}px`;
            }
        }

        hiddenPreview(dom) {
            if (dom) {
                dom.style.display = "none";
            }
        }
        showPreview(dom) {
            if (dom) {
                dom.style.display = "block";
            }
        }

        removePreview() {
            if (this.imgDom) {
                document.body.removeChild(this.imgDom);
                this.imgDom = null;
            }
        }

        removeTextPreview() {
            if (this.textDom) {
                document.body.removeChild(this.textDom);
                this.textDom = null;
            }
        }

        handleAddTitleText(item) {
            window["_view"].addTextFromTextPanel(this.$t(item.title), {
                size: item.canvaSize,
                bold: item.canvaSize !== 12,
            });
        }

        doMousedown(item) {
            let isMove = false;

            this.createTextPreview(item);
            let timer = setTimeout(() => {
                isMove = true;
            }, 150);

            document.onmousemove = (ev: MouseEvent) => {
                if (!isMove) return;
                this.showPreview(this.textDom);
                const imgWidth = 32,
                    imgHeight = 32;
                this.movePreview(this.textDom, ev.pageX - imgWidth / 2, ev.pageY - imgHeight / 2);
            };
            document.onmouseup = (ev: MouseEvent) => {
                clearTimeout(timer);
                const left = ev.pageX - this.sceneLeft,
                    top = ev.pageY - this.sceneTop;
                document.onmousemove = null;
                document.onmouseup = null;
                this.removeTextPreview();
                this.sensors.track("useSymbolLibrary", {
                    Catalogues: "editFileProcess",
                    symbol_library_name: this.$tc(item.title, 1, "en"),
                    symbol_library_class: "text",
                });
                window["_view"].addTextFromTextPanel(
                    this.$t(item.title),
                    {
                        size: item.canvaSize,
                        bold: item.canvaSize !== 12,
                    },
                    isMove,
                    top,
                    left
                );
            };
        }

        handleClickType(typeItem) {
            if (this.loading) return;
            this.activeType = typeItem.value;
            this.pageInfo.offset = 0;
            this.pageInfo.shape_num = typeItem.value;
            this.end = false;
            this.getData();
        }

        handleMousedown(e, item, index) {
            let isMove = false;
            let x = e.pageX;
            let y = e.pageY;
            this.createPreview(item.imgSrc);
            let changeShapeFlag = false;
            let timer = setTimeout(() => {
                isMove = true;
            }, 150);

            document.onmousemove = (ev: MouseEvent) => {
                if (!isMove) return;
                this.showPreview(this.imgDom);
                const imgWidth = 32,
                    imgHeight = 32;
                this.movePreview(this.imgDom, ev.pageX - imgWidth / 2, ev.pageY - imgHeight / 2);
                let movex = ev.pageX - x;
                let movey = ev.pageY - y - this.sceneTop;
                if (x + movex > this.sceneLeft) {
                    let obj = {
                        x: x + movex - this.sceneLeft,
                        y: y + movey,
                    };
                    if (!changeShapeFlag) {
                        // 移出的时候，一次性删除原预览图
                        this.removePreview();
                        changeShapeFlag = true;

                        window["_view"].dragEnter([
                            {
                                dragID: 0,
                                langName: "",
                                name: "",
                                obj,
                                shape: item.shapeData,
                            },
                        ]);
                    }
                    window["_view"].dragMove(ev);
                } else {
                    if (changeShapeFlag) {
                        // 移回的时候，恢复原预览图
                        window["_view"].dragLeave();
                        this.createPreview(item.imgSrc);
                        changeShapeFlag = false;
                        this.mouseMoveBack = true;
                    }
                    this.movePreview(this.imgDom, ev.pageX - imgWidth / 2, ev.pageY - imgHeight / 2);
                }
            };
            document.onmouseup = (ev: MouseEvent) => {
                clearTimeout(timer);
                const isLimitShape = !this.vip && index > 5;
                // if (isLimitShape && index > 5) {
                //     // PPT文字：每个分类下面的前6个可以免费使用
                //     this.$checkAuth({
                //         type: "limitShapeType",
                //         buyTrigger: "library",
                //         libraryName: '',
                //     });
                // }
                changeShapeFlag && window["_view"].iTextDropToScene(ev, isLimitShape);
                if (changeShapeFlag && isLimitShape) {
                    this.sensors.track("tryVipBenefit", {
                        Catalogues: "editFileProcess",
                        trial_vip_benefit: "text",
                    });
                }
                // window["_view"].group();
                document.onmousemove = null;
                document.onmouseup = null;
                this.removePreview();
                this.sensors.track("useSymbolLibrary", {
                    Catalogues: "editFileProcess",
                    symbol_library_name: this.trackKey,
                    symbol_library_class: "text",
                });
                window["_view"].updateRulers();
            };
        }

        handleClickImg(item, index) {
            if (this.mouseMoveBack) {
                this.mouseMoveBack = false;
                return;
            }
            const isLimitShape = !this.vip && index > 5;
            window["_view"]._tool.endEdit();
            window["_view"].iTextDbClickAddShape(item.shapeData, item.name, "", 0, isLimitShape);
            if (isLimitShape) {
                this.sensors.track("tryVipBenefit", {
                    Catalogues: "editFileProcess",
                    trial_vip_benefit: "text",
                });
            }
            this.sensors.track("useSymbolLibrary", {
                Catalogues: "editFileProcess",
                symbol_library_name: this.trackKey,
                symbol_library_class: "text",
            });
        }

        async getEdeFile(url) {
            let shapeData;
            let res = await this.$edApi.downloadTextEdeFile({ url });
            if (res.status === 200) {
                let reader = new FileReader();
                reader.readAsText(res.data);
                let promise = new Promise((resolve, reject) => {
                    reader.onload = (e) => {
                        let dataArr = (<any>e.target).result.match(/\<\!\-\-([\s\S]*?)\-\-\>/g);
                        shapeData = dataArr[0].replace(/(<!--)|(-->)/g, "");
                        resolve();
                    };
                });
                await promise;
            }
            return shapeData;
        }

        async getRenderData(IData) {
            let data = IData.list;
            if (IData.host && IData.suffix) {
                this.baseHost = IData.host;
                this.suffix = IData.suffix;
            }
            let promises = data
                .map(async (v) => {
                    let shapeData = await this.getEdeFile(`${this.baseHost}/${v.url}${this.suffix[0]}`);
                    if (shapeData) {
                        return {
                            ...v,
                            imgSrc: `${this.baseHost}/${v.url}${this.suffix[1]}`,
                            shapeData,
                        };
                    }
                })
                .filter(Boolean);
            let finalData = await Promise.all(promises);
            return finalData;
        }
        async getData() {
            if (this.loading) return;
            this.cancelObserve();
            this.loading = true;
            // this.textList = [];
            try {
                let res = await this.$edApi.getTextListData(this.pageInfo);
                if (res.data?.status == "success" && res.data?.data) {
                    let finalData = await this.getRenderData(res.data.data);
                    this.textList = finalData;
                    if (res?.data?.data?.list.length === res?.data?.data.total) {
                        this.end = true;
                    }
                    this.sensors.track("openLibrarySuccess", {
                        Catalogues: "editFileProcess",
                        name: this.trackKey,
                        class: "icon",
                    });
                }
            } finally {
                this.loading = false;
            }
            this.$nextTick(() => {
                this.registObserve();
            });
        }
        nextPage() {
            if (this.loading) return;
            this.loading = true;
            this.pageInfo.offset = this.pageInfo.offset + this.pageInfo.count;
            this.$edApi
                .getTextListData(this.pageInfo)
                .then((res) => {
                    if (res.data.status == "success") {
                        this.getRenderData(res.data.data).then((newData) => {
                            this.textList = this.textList.concat(newData);
                            if (res?.data?.data?.list.length == 0) {
                                this.end = true;
                            }
                        });
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        }

        registObserve() {
            this.cancelObserve();
            this.addObserve();
        }
        cancelObserve() {
            if (this.observe) {
                this.observe.unobserve(this.$refs.scrollEl);
                this.observe = null;
            }
        }
        addObserve() {
            if (this.observe) return;
            let dom = this.$refs.scrollEl;
            if (dom) {
                this.observe = new (window as any).IntersectionObserver((e: any) => {
                    if (e[0] && e[0].isIntersecting && !this.loading) {
                        this.nextPage();
                    }
                });
                this.observe.observe(dom);
            }
        }
        created() {}
        mounted() {
            this.getData();
        }
        beforeDestroy() {
            this.cancelObserve();
        }
    }
</script>
<i18n>
{
    "zh": {
        "addTitle": "单击添加标题",
        "addSubTitle": "单击添加副标题",
        "addContent": "单击添加正文",
        "textTemplate": "文字排版",
        "2Items": "2项",
        "3Items": "3项",
        "4Items": "4项",
        "5Items": "5项",
        "5Items": "5项",
        "mulItems": "多项",
        "nodata": "暂无数据",
        "smartItems": "智能"
    },
    "en": {
        "addTitle": "Add Title",
        "addSubTitle": "Add Subtitle",
        "addContent": "Add Body Text",
        "textTemplate": "Text Layout",
        "2Items": "2 Texts",
        "3Items": "3 Texts",
        "4Items": "4 Texts",
        "5Items": "5 Texts",
        "mulItems": "Multiple",
        "nodata": "Nothing here",
        "smartItems": "Smart"
    },
    "fr": {
        "addTitle": "Ajouter un titre",
        "addSubTitle": "Ajouter un sous-titre",
        "addContent": "Ajouter du texte",
        "textTemplate": "Disposition du texte",
        "2Items": "2 textes",
        "3Items": "3 textes",
        "4Items": "4 textes",
        "5Items": "5 textes",
        "mulItems": "Multiple",
        "nodata": "Aucun contenu",
        "smartItems": "Intelligent"
    },
    "de": {
        "addTitle": "Titel hinzufügen",
        "addSubTitle": "Untertitel hinzufügen",
        "addContent": "Text hinzufügen",
        "textTemplate": "Textlayout",
        "2Items": "2 Texte",
        "3Items": "3 Texte",
        "4Items": "4 Texte",
        "5Items": "5 Texte",
        "mulItems": "Mehrere Texte",
        "nodata": "Hier ist nichts",
        "smartItems": "selbstanpassend"
    },
    "jp": {
        "addTitle": "タイトルを追加",
        "addSubTitle": "サブタイトルを追加",
        "addContent": "本文を追加",
        "textTemplate": "テキストレイアウト",
        "2Items": "2個のテキスト",
        "3Items": "3個のテキスト",
        "4Items": "4個のテキスト",
        "5Items": "5個のテキスト",
        "mulItems": "複数",
        "nodata": "何もありません",
        "smartItems": "スマート"
    },
    "es": {
        "addTitle": "Añadir título",
        "addSubTitle": "Añadir subtítulo",
        "addContent": "Añadir cuerpo de texto",
        "textTemplate": "Diseño de texto",
        "2Items": "2 textos",
        "3Items": "3 textos",
        "4Items": "4 textos",
        "5Items": "5 textos",
        "mulItems": "Varios",
        "nodata": "Nada",
        "smartItems": "Inteligente"
    },
    "pt": {
        "addTitle": "Adicionar título",
        "addSubTitle": "Adicionar subtítulo",
        "addContent": "Adicionar corpo do texto",
        "textTemplate": "Layout de texto",
        "2Items": "2 textos",
        "3Items": "3 textos",
        "4Items": "4 textos",
        "5Items": "5 textos",
        "mulItems": "Vários",
        "nodata": "Nada aqui",
        "smartItems": "Inteligente"
    },
    "it": {
        "addTitle": "Aggiungi titolo",
        "addSubTitle": "Aggiungi sottotitolo",
        "addContent": "Aggiungi testo",
        "textTemplate": "Disposizione del testo",
        "2Items": "2 testi",
        "3Items": "3 testi",
        "4Items": "4 testi",
        "5Items": "5 testi",
        "mulItems": "Più testi",
        "nodata": "Vuoto",
        "smartItems": "Smart"
    },
    "tw": {
        "addTitle": "新增標題",
        "addSubTitle": "新增子標題",
        "addContent": "新增本文",
        "textTemplate": "文字佈局",
        "2Items": "2則文字",
        "3Items": "3則文字",
        "4Items": "4則文字",
        "5Items": "5則文字",
        "mulItems": "多則",
        "nodata": "這裡沒有任何資料",
        "smartItems": "智慧"
    },
    "kr": {
        "addTitle": "제목 추가",
        "addSubTitle": "자막 추가",
        "addContent": "본문 텍스트 추가",
        "textTemplate": "텍스트 레이아웃",
        "2Items": "텍스트 2개",
        "3Items": "텍스트 3개",
        "4Items": "텍스트 4개",
        "5Items": "텍스트 5개",
        "mulItems": "다양한",
        "nodata": "여기에는 아무 내용도 없습니다.",
        "smartItems": "스마트"
    }
}
</i18n>
